import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'util/Constants';
import { useEffect } from 'react';
import { Fragment } from 'react';

const SubscriptionCancel = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => navigate(ROUTES.ONBOARDING), 2000);
    }, [navigate]);

    return (
        <Fragment>
            <div className="flex flex-col items-center justify-center h-screen">
                <div className="text-xl mb-4 text-red-500">Subscription Plan Creation Cancelled</div>
                <div className="text-gray-600">Redirecting you back to the onboarding process...</div>
            </div>
        </Fragment>
    );
};

export default SubscriptionCancel;
